import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'
import { reduxForm, startSubmit, submit } from 'redux-form'
import transformProps from 'loankeeper-common/containers/transformProps'
import { withUserConfig } from 'shared'
import { INSTANCE_NAME, SELECTOR_NAME, RFInitialValues } from '../../constants'
import { accountSearchPost } from 'src/store/account'

const valuesToData = (
  {
    title,
    balCodeId,
    accNo,
    personalNo,
    currenciesDisabled,
    currencies,
    accTypesDisabled,
    accTypes,
    nodesDisabled,
    nodes,
    status,
  },
  ccyLocked,
  page,
) =>
  // this must be exacly as API requests, even names of object must match!
  ({
    title,
    balcodeid: balCodeId,
    accno: accNo,
    personalno: personalNo,
    statusid: status,
    page,
    ccy: !currenciesDisabled || ccyLocked ? currencies : undefined,
    typeid: !accTypesDisabled ? accTypes : undefined,
    nodeid: !nodesDisabled ? nodes : undefined,
  })

const transForStore = (response) => response.Data

export default flowRight(
  withUserConfig('NodeID as node'),
  transformProps((props) => {
    const { selector, ccy, accNo, page } = props
    const instanceName = selector ? SELECTOR_NAME : INSTANCE_NAME

    return {
      ...props,
      form: instanceName,
      initialValues: {
        ...RFInitialValues,
        ...(ccy ? { currencies: ccy } : {}),
        ...(accNo ? { accNo } : {}),
        ...(page ? { page } : {}),
        nodes: props.node,
      },

      onSubmit: (values, dispatch, { submitting }) => {
        // if submitting is true due to startSubmit, we have first submit on mount, otherwise submitting is false
        const data = valuesToData(values, selector && ccy, submitting ? page : undefined)
        // return new Promise((resolve, reject) => {
        //   dispatch(
        //     fetchSFM({
        //       instanceName,
        //       callApi: Account.search,
        //       callApiArgs: [data],
        //       transformResponse: transForStore,
        //       resolve,
        //       reject,
        //     }),
        //   )
        // })

        //UPDATED API REQUEST 'acc_account_search'
        return dispatch(
          accountSearchPost({
            Title: data.title,
            BalCodeID: data.balcodeid,
            AccNo: data.accno,
            PersonalNo: data.personalno,
            StatusID: data.statusid,
            Page: data.page,
            CCY: data.ccy,
            TypeID: data.typeid,
            NodeID: data.nodeid,
            instanceName,
          }),
        )
      },
    }
  }),

  reduxForm({
    destroyOnUnmount: false,
  }),

  connect(undefined, (dispatch, { selector }) => ({
    submit: () => {
      const instanceName = selector ? SELECTOR_NAME : INSTANCE_NAME
      dispatch(startSubmit(instanceName))
      dispatch(submit(instanceName))
    },
  })),
)
